import React from "react";

export const FailureIconInner = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="102" height="102" viewBox="0 0 102 102" fill="none" className={className}>
    <circle opacity="0.15" cx="51" cy="51" r="51" fill="#F23D3D"><animate
      attributeName="opacity"
      values="0.15;0.5;0.15"
      dur="2s"
      repeatCount="indefinite"
    /></circle>
    <circle cx="51" cy="51" r="29" fill="#F23D3D"><animate
      attributeName="opacity"
      values="0.15;0.5;0.15"
      dur="2s"
      repeatCount="indefinite"
    /></circle>
    <mask id="mask0_1162_17475" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="29" y="28" width="45" height="45">
      <rect x="29.4639" y="28.464" width="44.536" height="44.536" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1162_17475)">
      <path d="M49.8762 54.4433V37.7423H53.5876V54.4433H49.8762ZM49.8762 63.7217V60.0103H53.5876V63.7217H49.8762Z" fill="white" />
    </g>
  </svg>
);

export const FailureCircleOuter = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="546" height="546" viewBox="0 0 546 546" fill="none" className={className}>
    <path opacity="0.4" fillRule="evenodd" clipRule="evenodd" d="M273 541C421.012 541 541 421.012 541 273C541 124.988 421.012 5 273 5C124.988 5 5 124.988 5 273C5 421.012 124.988 541 273 541ZM273 546C423.774 546 546 423.774 546 273C546 122.226 423.774 0 273 0C122.226 0 0 122.226 0 273C0 423.774 122.226 546 273 546Z" fill="#F00" />
  </svg>
);

export const FailureCircleMiddle = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="496" height="496" viewBox="0 0 496 496" fill="none" className={className}>
    <path opacity="0.05" fillRule="evenodd" clipRule="evenodd" d="M248 491.458C382.458 491.458 491.458 382.458 491.458 248C491.458 113.542 382.458 4.54212 248 4.54212C113.542 4.54212 4.54212 113.542 4.54212 248C4.54212 382.458 113.542 491.458 248 491.458ZM248 496C384.967 496 496 384.967 496 248C496 111.033 384.967 0 248 0C111.033 0 0 111.033 0 248C0 384.967 111.033 496 248 496Z" fill="#F00" />
  </svg>
);

export const RetryIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className={className}>
    <mask id="mask0_1_3" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1_3)">
      <path d="M12.05 20C9.81667 20 7.91667 19.225 6.35 17.675C4.78333 16.125 4 14.2333 4 12V11.825L2.4 13.425L1 12.025L5 8.025L9 12.025L7.6 13.425L6 11.825V12C6 13.6667 6.5875 15.0833 7.7625 16.25C8.9375 17.4167 10.3667 18 12.05 18C12.4833 18 12.9083 17.95 13.325 17.85C13.7417 17.75 14.15 17.6 14.55 17.4L16.05 18.9C15.4167 19.2667 14.7667 19.5417 14.1 19.725C13.4333 19.9083 12.75 20 12.05 20ZM19 15.975L15 11.975L16.4 10.575L18 12.175V12C18 10.3333 17.4125 8.91667 16.2375 7.75C15.0625 6.58333 13.6333 6 11.95 6C11.5167 6 11.0917 6.05 10.675 6.15C10.2583 6.25 9.85 6.4 9.45 6.6L7.95 5.1C8.58333 4.73333 9.23333 4.45833 9.9 4.275C10.5667 4.09167 11.25 4 11.95 4C14.1833 4 16.0833 4.775 17.65 6.325C19.2167 7.875 20 9.76667 20 12V12.175L21.6 10.575L23 11.975L19 15.975Z" fill="white" />
    </g>
  </svg>
);
